<template>
    <md-dialog
      :md-close-on-esc="false"
      :md-click-outside-to-close="false"
      :md-active.sync="visibleCurrentForm"
    >
      <md-dialog-title>
        New Iwl application.
      </md-dialog-title>
      <md-dialog-content>
        <div class="md-layout md-gutter">
          <md-subheader class="sub-header">
            Choose deal type
          </md-subheader>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item ">
            <ValidatedSelectInput
              label="Type"
              v-model="form.type"
              :options="type.map(i => i.value)"
              required
            />
          </div>
          <div class="md-layout-item">
            <ValidatedSelectInput
              label="Provider"
              v-model="form.provider"
              :options="provider.map(i => i.name)"
              required
            />
          </div>
        </div>
        <!-- Policy data -->
        <div class="md-layout md-gutter">
          <md-subheader class="sub-header">
            Insurance details
          </md-subheader>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <validated-text-input
              class="md-layout-item md-size-100"
              label="Product"
              v-model="form.product"
              required
            />
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item ">
            <ValidatedSelectInput
              class="md-layout-item md-size-100"
              label="Cover Term"
              v-model="form.cover_term"
              :options="cover_term_options.map(i => i.value)"
              required
            />
          </div>
          <div class="md-layout-item">
            <validated-number-input
              class="md-layout-item md-size-100"
              label="Premium"
              v-model="form.premium"
              prefix="$"
              required
            />
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <validated-number-input
              class="md-layout-item"
              label="Income"
              v-model="form.income"
              prefix="$"
              required
            />
          </div>
          <div class="md-layout-item">
            <validated-text-input
              class="md-layout-item md-size-100"
              label="Policy Number"
              v-model="form.serial_number"
              required
            />
          </div>
        </div>
        <!-- Client data -->
        <div class="md-layout md-gutter">
          <md-subheader class="sub-header">
            Client details
          </md-subheader>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <validated-text-input
              class="md-layout-item md-size-100"
              label="Client FirstName"
              v-model="form.client_first_name"
              regex = "^[A-Za-z ']+$"
              errormsg="Only characters are accepted."
              required
            />
          </div>
          <div class="md-layout-item">
            <validated-text-input
              class="md-layout-item"
              label="Client LastName"
              v-model="form.client_last_name"
              regex = "^[A-Za-z ']+$"
              errormsg="Only characters are accepted."
              required
            />
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <validated-text-input
              class="md-layout-item"
              label="Client Phone"
              v-model="form.client_phone"
              prefix="+"
              :minLength=7
              :maxLength=15
              regex = "^\d+$"
              errormsg="Phone can contain 7 to 15 digits"
              required
            />
          </div>
          <div class="md-layout-item">
            <validated-email-input
              class="md-layout-item md-size-100"
              label="Client Email"
              v-model="form.client_email"
              required
            />
          </div>
        </div>
        <!-- SDB-641 implement in the future -->
        <!-- Broker data -->
        <!-- <div class="md-layout md-gutter">
          <md-subheader class="sub-header">
            Broker details
          </md-subheader>
        </div> -->
        <!-- <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <validated-text-input
              class="md-layout-item"
              label="Broker LastName"
              v-model="brokerLastName"
              disabled
            />
          </div>
          <div class="md-layout-item">
            <validated-text-input
              class="md-layout-item md-size-100"
              label="Broker FirstName"
              v-model="brokerFirstName"
              disabled
            />
          </div>
        </div> -->
        <!-- <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <validated-text-input
              label="Broker Email"
              v-model="brokerEmail"
              disabled
            />
          </div>
        </div> -->
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary md-simple" @click="onCancel">
          Cancel
        </md-button>
        <loading-icon-text-button
          class="md-primary"
          @click="onSave"
          icon="save"
          :loading="isSaving"
        >
          Save
        </loading-icon-text-button>
      </md-dialog-actions>
    </md-dialog>
  </template>
  <script>
    import filters from "@/components/utils/filters";
    import ValidatedInputs from "@/components/ValidatedInput";
    import LoadingIconTextButton from "@/components/LoadingIconTextButton";
    import AlertDialog from "@/components/Dialogs/AlertDialog";
    import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";
    import {mapGetters} from "vuex";

    export default {
      components:{
        LoadingIconTextButton,
        ...ValidatedInputs,
        ConfirmDialog,
        AlertDialog
      },
      props: {
        application: {
          type: Object | Array,
        },
        visible: {
          default: false,
          type: Boolean,
        },
      },
      data() {
        return {
          referrerByPod: [],
          visibleCurrentForm: false,
          isSaving: false,
          type: [
           { value: 'Insurance' },
           { value: 'Warranty' },
          ],
          cover_term_options: [
           { value: 12 },
           { value: 24 },
           { value: 36 },
           { value: 48 },
           { value: 60 },
          ],
          form: {
            type: '',
            provider: '',
            client_last_name: '',
            client_last_name: '',
            product: '',
            cover_term: '',
            premium: '',
            income: '',
            client_phone: '',
            client_email: '',
            serial_number: '',
          },
        }
      },
      computed: {
        ...mapGetters([
          "user",
          "options"
        ]),
        // SDB-641 implement in the future
        // brokerFirstName() {
        //   if (this.user !== null)
        //     return this.user.first_name;
        // },
        // brokerLastName() {
        //   if (this.user !== null)
        //     return this.user.last_name;
        // },
        // brokerEmail() {
        //   if (this.user !== null)
        //     return this.user.email;
        // },
        provider() {
          switch (this.form.type) {
            case 'Insurance':
              this.form.provider = 'Suncorp';
              return [
                { name: 'Suncorp' },
                { name: 'Koba' },
                { name: 'AWN' },
                { name: 'CIL' },
                { name: 'ClubMarine' },
                { name: 'MIBike' },
              ];
            case 'Warranty':
              this.form.provider = 'Integrity';
              return [
                { name: 'Integrity' },
                { name: 'AWN' },
              ];
            default:
              return [];
          }
        },

      },
      methods:{
        ...filters,
        async onSave() {
          try {
            await axios.post("/api/v1/tools/save_insurance_warranty_deal", {"form": this.form});
            this.showModal('Data saved successfully.', 'Success')
            this.onCancel();
          } catch (error) {
            let descr = '';
            if (error.response != null) {
              descr = error.response.data;
            }
            this.showModal(error + ' Description: ' + descr, 'Error');
            console.log('error: ' + error + ' Description: ' + descr);
          }
        },

        showModal(message, title) {
          this.$modal.show(ConfirmDialog, {
            title: title,
            message: message,
            confirmText: "Ok",
          });
        },

        onCancel() {
          this.resetForm();
          this.visibleCurrentForm = false;
          this.$emit("close");
        },

        resetForm() {
          this.form.type = '';
          this.form.provider = '';
          this.form.client_last_name = '';
          this.form.client_first_name = '';
          this.form.product = '';
          this.form.cover_term = '';
          this.form.premium = '';
          this.form.income = '';
          this.form.client_phone = '';
          this.form.client_email = '';
          this.form.serial_number = '';
        },
      },
      filters: {
        // make all filters available as filters
        ...filters,
      },
      created() {
        // for existing applications where the trade in value in asset is not set
        this.$store.dispatch('get_lender_query', false);
      },
      watch: {
        visible (value) {
          this.visibleCurrentForm = value;
        },
        application (value) {
          this.form = value;
        }
      }
    }
  </script>
